import React, { useEffect, useRef, useState } from "react";
import Select from "react-select";
import "../../Styles/ProductPage.css";
import DownArrow from "../../Assests/Dashboard/Down.svg";
import CloseIcon from "../../Assests/Dashboard/cross.svg";
import Validation from "../../Constants/Validation";
import { useLocation } from "react-router-dom";
import Skeleton from "react-loading-skeleton";
import TuneIcon from "@mui/icons-material/Tune";
import CircularProgress from "@mui/material/CircularProgress";
import { styled, Tooltip, tooltipClasses, Zoom } from "@mui/material";
import { IoInformationCircleOutline } from "react-icons/io5";
const LoadingOptions = () => {
  return (
    <div className="options-box custom-scroll">
      {["100", "200", "75", "250", "250"].map((item) => (
        <div className="item" key={item}>
          <span>
            <Skeleton style={{ width: `${item}px` }} />
          </span>
        </div>
      ))}
    </div>
  );
};
const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: "none", // disables MUI default maxWidth
    width: "300px", // fixed width you want
    backgroundColor: "var(--qv-bg-f5f5f5, #F5F5F5)",
    color: "var(--qv-tx-000000, #000)",
    fontSize: "0.875rem",
    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.2)",
    border: "1px solid var(--qv-bd-dddddd, #ddd)",
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: "#F5F5F5",
  },
}));
const HoverInfoLogo = ({ title, placement }) => {
  return (
    <CustomWidthTooltip
      title={title}
      arrow
      placement={placement ? placement : "bottom-end"}
      TransitionComponent={Zoom}
    >
      <div className="ms-2" style={{ display: "inline-block" }}>
        <IoInformationCircleOutline
          style={{
            height: "20px",
            width: "20px",
            cursor: "pointer",
            position: "relative",
          }}
        />
      </div>
    </CustomWidthTooltip>
  );
};
function SearchableDropdownForBogo({
  title,
  keyName,
  optionList,
  handleSelectProductOptions,
  handleDeleteSelectedOption,
  selectedOption,
  error,
  handleUpdateError,
  name,
  hideSelectedValue,
  hideSelectedList,
  placeholder,
  pageUrl,
  productTitle,
  modalType,
  usingFor,
  setProductName = false,
  optionsLoading = false,
  errorClass,
  isFilterIcon,
  handleOpenCategoryModal,
  allowedAllSelect,
  selectFocusOnSuccess,
  loading,
  categoryInvalidError,
  lockedIds = [], // options that stay selected and cannot be removed
}) {
  const isLockedOption = (id) =>
    lockedIds?.some((lockedId) => String(lockedId) === String(id));
  const location = useLocation();
  const { checkLength } = Validation();
  const [filterOptions, setFilterOptions] = useState(optionList);
  const [filterValue, setFilterValue] = useState("");
  const isProductAdd = location.pathname.includes("/products/add");
  const isProductEdit = location.pathname.includes("/products/edit");
  const isVarientMerging = location.pathname.includes("/inventory-merge");
  const isProductDuplicate = location.pathname.includes(
    "/products/duplicate-product"
  );
  const handleFilterOptions = (e) => {
    const { value } = e?.target;
    setFilterValue(value);
    typeof setProductName === "function" && setProductName(value); // for deven
    if (usingFor === "variantProducts") return;
    const filterList = optionList?.filter((item) => {
      return item?.[name]?.toLowerCase()?.includes(value?.toLowerCase());
    });
    setFilterOptions(
      filterList?.length ? filterList : ["No Search Result Found"]
    );
  };
  const [showOptions, setShowOptions] = useState(false);
  const ref = useRef();
  const dropdownRef = useRef(null);
  useEffect(() => {
    if (usingFor === "variantProducts") return;

    setFilterValue("");

    // hide selected value if hideSelectedValue = true
    if (hideSelectedValue === true && hideSelectedList?.length) {
      const hideItemList = optionList?.filter((filtered) => {
        return !hideSelectedList?.some((item) => +item?.id === +filtered?.id);
      });
      setFilterOptions(hideItemList);
    }
  }, [selectedOption, hideSelectedValue, hideSelectedList, optionList]);
  useEffect(() => {
    if (selectFocusOnSuccess) {
      ref.current.focus();
    }
  }, [selectFocusOnSuccess]);
  useEffect(() => {
    // remove category error if exist.
    if (selectedOption?.length > 0 && !!handleUpdateError) {
      checkLength(keyName, selectedOption, error);
      handleUpdateError(error);
    }
  }, [selectedOption]);
  const handleClickOutside = (event) => {
    if (
      location.pathname.includes("/mix-and-match") ||
      location.pathname.includes("/bogo-pricing")
    ) {
      return;
    } else if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target)
    ) {
      setShowOptions(false);
    }
  };
  useEffect(() => {
    if (!modalType) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [showOptions, modalType]);
  useEffect(() => {
    // set defaultTax in taxes dropdown
    if (
      optionList?.length &&
      keyName === "taxes" &&
      (isProductAdd || isVarientMerging)
    ) {
      const findOption = optionList?.filter(
        (item) => item?.title === "DefaultTax"
      );
      handleSelectProductOptions(findOption[0], keyName);
    }
  }, [optionList, keyName, productTitle]);
  const changeFilterableList = () => {
    const filterOptionList = optionList?.filter(
      (product) =>
        !product?.title?.toLowerCase()?.includes(productTitle?.toLowerCase())
    );
    // filter incoming optionList items when onchange run
    if (filterOptions?.length) {
      return isProductEdit || isProductDuplicate
        ? filterOptions?.filter(
            (product) =>
              !product?.title
                ?.toLowerCase()
                .includes(productTitle?.toLowerCase())
          )
        : filterOptions;
    }
    return isProductEdit ? filterOptionList : optionList;
  };
  const toggleOption = () => {
    // toggle optionsPanel
    setShowOptions(!showOptions);
  };
  const handleFocus = (e) => {
    const { name } = e.target;
    ref.current.focus();
    setShowOptions(true);
  };
  const handleBlurOption = async (e) => {
    const { name } = e.target;
    if (name === "category" && error) {
      await checkLength(keyName, selectedOption, error);
      handleUpdateError(error);
    }
  };
  return (
    <>
      {title ? (
        <div
          className={`title-area items-center flex ${
            isFilterIcon ? "mix-match-filter-product" : ""
          }`}
        >
          <div className="CircularSTDMedium-16px">{title}</div>
          <HoverInfoLogo
            title={
              "The deal will be copied to the selected store. If the selected product for the deal is not present in the selected store, it will be copied from the currently logged-in store."
            }
          />
          <div className="icon-area">
            {isFilterIcon ? <span>Category &nbsp;</span> : ""}
            {isFilterIcon ? (
              <span
                className="mix-match-filter-icon"
                onClick={handleOpenCategoryModal}
              >
                <TuneIcon />
              </span>
            ) : (
              ""
            )}
          </div>
        </div>
      ) : (
        ""
      )}
      <div
        className="dropdownBox "
        style={{
          padding: showOptions
            ? "0px 8px 8px 8px"
            : !!modalType
              ? ""
              : "0px 8px 0px 8px",
        }}
        onBlur={handleBlurOption}
        name={keyName}
        ref={dropdownRef}
      >
        <div
          className="search-area"
          style={{ borderBottom: showOptions ? "1px solid var(--qv-bd-ececec, #ececec)" : "" }}
          name={keyName}
          onBlur={handleBlurOption}
        >
          <div
            className={
              !!modalType
                ? "search-selected-item-without-padding"
                : "search-selected-item"
            }
            onClick={handleFocus}
          >
            <div className="selected-item ">
              {selectedOption?.length
                ? selectedOption?.map((option) => {
                    return (
                      <div
                        className="item"
                        key={
                          option?.isvarient === "1"
                            ? option?.var_id
                            : option?.id
                        }
                      >
                        <span>{option?.[name]}</span>
                        {isLockedOption(option?.id) ? (
                          ""
                        ) : (
                          <img
                            src={CloseIcon}
                            alt=""
                            className="cancel-image"
                            onClick={() =>
                              handleDeleteSelectedOption(
                                option?.id,
                                keyName,
                                option
                              )
                            }
                          />
                        )}
                      </div>
                    );
                  })
                : ""}
            </div>
            <input
              ref={ref}
              type="text"
              placeholder={placeholder}
              name={keyName}
              className="search-item"
              value={filterValue}
              onFocus={handleFocus}
              onChange={handleFilterOptions}
              onKeyDown={(e) => {
                // Barcode scanners append Enter after the code; never submit the parent form.
                if (e.key === "Enter") {
                  e.preventDefault();
                  e.stopPropagation();
                }
              }}
              autoComplete={false}
            />
          </div>
          <div className="toggle-btn">
            <img
              src={DownArrow}
              alt=""
              className={
                showOptions
                  ? "down-arrow-image rotate-dropdpown"
                  : "down-arrow-image remove-rotate-dropdown"
              }
              onClick={toggleOption}
            />
          </div>
        </div>
        {showOptions ? (
          <div className="options-box custom-scroll">
            {showOptions && !optionsLoading ? (
              changeFilterableList()?.length > 0 ? (
                changeFilterableList().map((opt) => {
                  const isInSelectedOptions = selectedOption?.some(
                    (selected) =>
                      usingFor === "variantProducts" &&
                      selected.isvarient === "1"
                        ? selected?.id === opt?.id &&
                          selected.var_id === opt.var_id
                        : selected?.id === opt?.id
                  );
                  if (typeof opt === "string") {
                    return <p>{opt}</p>;
                  } else if (opt?.id && opt?.[name]) {
                    const isLocked = isLockedOption(opt?.id);
                    return (
                      <span
                        className={`${
                          isInSelectedOptions ? "item active-item" : "item"
                        }${isLocked ? " locked-item" : ""}`}
                        key={opt.isvarient === "1" ? opt.var_id : opt?.id}
                        onClick={() => {
                          if (isLocked) return;
                          isInSelectedOptions
                            ? handleDeleteSelectedOption(opt?.id, keyName, opt)
                            : handleSelectProductOptions(opt, keyName);
                        }}
                      >
                        {opt?.[name]}
                      </span>
                    );
                  }
                })
              ) : (
                <div className="options-box custom-scroll">
                  <p className="">No Products found</p>
                </div>
              )
            ) : (
              <LoadingOptions />
            )}
          </div>
        ) : (
          ""
        )}
      </div>
      {error?.[keyName] ? (
        <span className={`error-alert ${errorClass}`}>{error?.[keyName]}</span>
      ) : (
        ""
      )}
      {categoryInvalidError ? (
        <p
          className="error-alert mb-2"
          style={{ fontSize: "12px", fontWeight: 500, marginTop: "5px" }}
        >
          You can select a maximum of 10 items only.
        </p>
      ) : null}
    </>
  );
}
export default SearchableDropdownForBogo;
